'use strict';

import BaseService from './base.service';

class VehiclesService extends BaseService {
  /* @ngInject */
  constructor(Vehicle, SegaUser) {
    super(Vehicle, SegaUser);
    Object.assign(this, { Vehicle });
  }

  getVehicles(opts = {}) {
    return this.getModels(opts);
  }

  getQueryOpts(options) {
    return super.getQueryOpts(options).then(queryOpts => {
      if (queryOpts.where.broad) {
        let whereText = queryOpts.where.broad;
        delete queryOpts.where.broad;

        let orQuery = {
          or: [
            {
              number: {
                ilike: `%${whereText}%`
              }
            },
            {
              plate: {
                ilike: `%${whereText}%`
              }
            },
            {
              description: {
                ilike: `%${whereText}%`
              }
            }
          ]
        };

        queryOpts.where = Object.assign(queryOpts.where, orQuery);
      }
      return queryOpts;
    });
  }
}

export default VehiclesService;
